/**
 * 最大カラムスパン値
 */
const maxColSpanValue = 7;

/**
 * colSpanに応じたTailwindクラス名のマッピング
 */
export const colSpanClasses = {
  1: 'col-span-1',
  2: 'col-span-2',
  3: 'col-span-3',
  4: 'col-span-4',
  5: 'col-span-5',
  6: 'col-span-6',
  7: 'col-span-7'
} as const;

/**
 * AttributeCardProps等で使用するcolSpanの型定義のためのヘルパー型
 */
type IntegerRange<T extends number, Acc extends number[] = [1]> = Acc['length'] extends T ? Acc[number] | T : IntegerRange<T, [...Acc, Acc['length']]>;

/**
 * カラムスパン値の型定義（1〜maxColSpanValueの整数）
 */
export type ColSpan = IntegerRange<typeof maxColSpanValue>;